import React from "react";
import styled from "styled-components";
import WGLogo from "../images/WGLogo.png";
import LoginWrap from "./LoginWrap";

const CommonPage = () => {
  return (
    <BodyWrap>
      <PageWrap>
        <Header>
          <LogoImage src={WGLogo} alt="logo" />
          <span>WG 프로젝트</span>
        </Header>
        <LoginWrap />
      </PageWrap>
    </BodyWrap>
  );
};
export default CommonPage;

const BodyWrap = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: start;
  align-items: start;
  background-color: #f0f0f0;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 28px;
  font-size: 12px;

  color: #bdbdbd;
`;

const LogoImage = styled.img`
  width: 15px;
  height: 16px;
`;

const PageWrap = styled.div`
  width: 1920px;
  height: 911px;
  padding-top: 7px;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  gap: 20px;
`;
